<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div class="text-caption">
        <iri-value :iri="name" :highlights="highlights" humanize>{{
          hover
        }}</iri-value>
      </div>
    </v-hover>
    <div v-for="(v, index) of dataProperty.values" :key="index" class="mb-1">
      <!-- display: block -->
      <literal-value
        :literal="v"
        :highlights="highlights"
        :encoding="isCoordinates ? 'geocoord' : 'no-encoding'"
      ></literal-value>
    </div>
  </div>
</template>

<script>
// TODO add scroll with blur similar to object property for large data property values, eg Geometries GML.
import IriValue from './IriValue.vue'
import LiteralValue from './LiteralValue.vue'

import { DataProperty, Iris } from '@/rec-cache/rec-cache-types'

export default {
  // TODO refactor literal geocoords into own component after all.
  // TODO add config flag for conversions of data properties. May be done with date-time as well.

  components: { IriValue, LiteralValue },

  props: {
    dataProperty: {
      type: Object,
      default: () => {
        return new DataProperty()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
  },
  computed: {
    name: function () {
      return this.dataProperty.name
    },
    isCoordinates: function () {
      return this.name.value == Iris.recCoordinates
    },
  },
}
</script>
